export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 mx-3 md:mx-5 my-3 md:my-5 rounded-2xl md:rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20aesthetic%20flat%20lay%20composition%20of%20fashion%20accessories%20including%20a%20pair%20of%20clean%20white%20designer%20sneakers%20and%20a%20neatly%20folded%20beige%20cashmere%20sweater%20on%20a%20soft%20cream%20textured%20surface%20with%20warm%20natural%20sunlight%20casting%20elegant%20shadows%2C%20editorial%20product%20photography%2C%20elevated%20minimal%20style%2C%20soft%20cream%20and%20warm%20neutral%20color%20palette&width=1800&height=900&seq=hero-bg-v3&orientation=landscape"
          alt="Hoobuy Spreadsheet 2026 - Produtos e Fornecedores"
          title="Melhor Hoobuy Spreadsheet 2026"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col items-center text-center px-4 md:px-6 pt-16">
        <div className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
          <span className="text-xs md:text-sm text-white font-medium">Atualizado Hoje — Junho 2026</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white leading-tight max-w-4xl">
          Melhor Hoobuy<br className="hidden sm:block" /> Spreadsheet 2026
        </h1>

        <p className="mt-4 md:mt-6 text-sm md:text-base lg:text-lg text-white/80 max-w-2xl font-light">
          Mais de 1000 links atualizados diariamente para Brasil e Portugal.
          Encontre os melhores fornecedores, produtos populares e guias completos em um só lugar.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 md:mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white text-sm md:text-base font-medium hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
          >
            Explorar Agora
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}